import { getSellerCommunicationTemplate } from 'Pages/api/seller-communications/template/client.api';

import { validateBody } from './helpers';
import { EmailBodyStore, ModalFlowStore } from './stores';
import { ModalSteps } from './types';

export const onBackButtonCLick = () => {
	ModalFlowStore.setState({ currentStep: ModalSteps.EnquirySelection });
};

export const onGetSellerCommunicationTemplate = async () => {
	try {
		const {
			templates: [firstTemplate],
		} = await getSellerCommunicationTemplate();
		if (firstTemplate) {
			const { body, templateId } = firstTemplate;
			EmailBodyStore.setState({ body, isBodyEmpty: body.length === 0, templateId });
		}
	} catch {
		// ignore error
	}
};

export const onBodyChange = (body: string) => {
	const bodyError = validateBody(body);
	const isBodyEmpty = body.length === 0;
	EmailBodyStore.setState({ body, bodyError, isBodyEmpty });
};

export const onSaveAsDefaultChange = (saveAsDefaultBody: boolean) => EmailBodyStore.setState({ saveAsDefaultBody });

export const emailEditorService = {
	onBackButtonCLick,
	onBodyChange,
	onGetSellerCommunicationTemplate,
	onSaveAsDefaultChange,
};
